export const ONSITE_EDITOR_DEPRECATION_ACKNOWLEDGED_KEY =
  "onsite-editor-deprecation-acknowledged";

export const hasAcknowledgedOnsiteEditorDeprecation = () => {
  try {
    return (
      localStorage.getItem(ONSITE_EDITOR_DEPRECATION_ACKNOWLEDGED_KEY) ===
      "true"
    );
  } catch {
    return false;
  }
};

export const acknowledgeOnsiteEditorDeprecation = () => {
  try {
    localStorage.setItem(ONSITE_EDITOR_DEPRECATION_ACKNOWLEDGED_KEY, "true");
  } catch {
    // Continue with the launch if localStorage is unavailable.
  }
};
